














import { defineComponent, PropType } from "@vue/composition-api";
import { Story } from "@scrile/api-provider/dist/projects/scrileConnect/StoriesProvider";
import BasePage from "@/components/BasePage";
import EmptyContent from "@/components/EmptyContent";
import PageTitle from "@/components/PageTitle";
import StoriesArchiveGrid from "./StoriesArchiveGrid.vue";
import StoriesArchiveSort from "./StoriesArchiveSort.vue";

export default defineComponent({
  name: "StoriesArchiveView",
  components: { EmptyContent, StoriesArchiveGrid, StoriesArchiveSort, PageTitle, BasePage },
  props: {
    enableScroll: { type: Boolean, default: false },
    selectedSort: { type: String },
    loading: { type: Boolean, default: false },
    stories: { type: Array as PropType<Story[]>, required: true },
  },
});
